<div class="container mb-5">
  <div class="row">
    <div class="col-12">
      <div class="row titolo-pagina">
        <div class="col-12">
          <h1 class="">
            {{ 'CREA_NUOVO_ACCOUNT' | translate | htmlToText  }}
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
            <form name="form" (ngSubmit)="f.form.valid && registra()" #f="ngForm" [mustMatch]="['password', 'confirmPassword']" novalidate>
                <div class="form-group">
                    <label for="nome" class="font-weight-semi-bold small">{{ 'NOME' | translate | htmlToText  }}*</label>
                    <input type="text" class="form-control" name="nome" id="nome" aria-describedby="" placeholder="" [(ngModel)]="user.nome"
                    #nome="ngModel" [ngClass]="{ 'is-invalid': f.submitted && nome.invalid }" required>
                    <div *ngIf="f.submitted && nome.invalid" class="invalid-feedback">
                      <div *ngIf="nome.errors.required">{{ 'NOME' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                    </div>
                  </div>
                    <div class="form-group">
                    <label for="cognome" class="font-weight-semi-bold small">{{ 'COGNOME' | translate | htmlToText  }}*</label>
                    <input type="text" class="form-control" name="cognome" id="cognome" aria-describedby="" placeholder="" [(ngModel)]="user.cognome"
                    #cognome="ngModel" [ngClass]="{ 'is-invalid': f.submitted && cognome.invalid }" required>
                    <div *ngIf="f.submitted && cognome.invalid" class="invalid-feedback">
                      <div *ngIf="cognome.errors.required">{{ 'COGNOME' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                    </div>
                  </div>
                    <div class="form-group">
                    <label for="email" class="font-weight-semi-bold small">{{ 'EMAIL' | translate | htmlToText  }}*</label>
                    <input type="email" class="form-control" name="email" id="email" aria-describedby="email" placeholder=""
                    [(ngModel)]="user.email" required email
                    #email="ngModel" [ngClass]="{ 'is-invalid': (f.submitted && email.invalid) || errorEmailEsistente  }">
                    <!-- ERRORE DATO INVALIDO -->
                    <!-- <div class="is-invalid small" *ngIf="emailMalformata"><i>{{ 'DATO_NON_VALIDO' | translate | htmlToText  }}</i></div> -->
                    <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                      <div *ngIf="email.errors.required">{{ 'EMAIL' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                      <div *ngIf="email.errors.email">{{ 'DATO_NON_VALIDO' | translate | htmlToText  }}</div>
                  </div>
                  <div *ngIf="errorEmailEsistente" class="invalid-feedback d-block">
                    <div >{{ errorEmailEsistente }}</div>
                  </div>
                    </div>
                    <div class="form-group">
                      <label for="password" class="font-weight-semi-bold small">{{ 'PASSWORD' | translate | htmlToText  }}*</label>
                      <input type="password" class="form-control" name="password" id="password" placeholder="" [(ngModel)]="user.password"
                       #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required minlength="6" >
                      <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                        <div *ngIf="password.errors.required">{{ 'PASSWORD' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                        <div *ngIf="password.errors.minlength">{{ 'PASSWORD_LENGTH' | translate | htmlToText  }}</div>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="confirmPassword" class="font-weight-semi-bold small">{{ 'RIPETI_PASSWORD' | translate | htmlToText  }}*</label>
                      <input type="password" class="form-control" name="confirmPassword" id="confirmPassword"
                        placeholder="" [(ngModel)]="user.confirmPassword"
                        #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }" required>
                      <!-- ERRORE DATO INVALIDO -->
                      <!-- <div class="is-invalid small" *ngIf="passwordNonCoincidono"><i>{{ 'PASSWORD_NON_COINCIDONO' | translate | htmlToText  }}</i></div> -->
                      <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                        <div *ngIf="confirmPassword.errors.required">{{ 'RIPETI_PASSWORD' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                        <div *ngIf="confirmPassword.errors.mustMatch">{{ 'PASSWORDS_MATCH' | translate | htmlToText  }}</div>
                      </div>
                    </div>
                    <div class="form-check">
                    <!-- VIENE INVIATA EMAIL A COMMERCIALE STEM CON NOTIFICA DI EMAIL CHE DESIDERA ISCRIVERSI -->
                    <input class="form-check-input" type="checkbox" value="yes" name="check-newsletter" id="check-newsletter"
                    [(ngModel)]="user.newsletter">
                    <label class="form-check-label small" for="check-newsletter">
                        {{ 'ISCRIVI_NEWSLETTER' | translate | htmlToText  }}
                    </label>
                    </div>
                    <div class="form-check">
                    <input class="form-check-input" required type="checkbox" value="yes" name="check-privacy" id="check-privacy" [(ngModel)]="user.privacy"
                    #privacy="ngModel" [ngClass]="{ 'is-invalid': f.submitted && privacy.invalid }" required >
                    <label class="form-check-label small" for="check-privacy">
                        {{ 'ACCETTO_PRIVACY' | translate | htmlToText  }} <span class="text-underline" [innerHTML]="'PRIVACY' | translate"></span>*
                    </label>
                    <div *ngIf="f.submitted && privacy.invalid" class="invalid-feedback">
                      <div *ngIf="privacy.errors.required">{{ 'PRIVACY' | translate | htmlToText  }} {{ 'REQUIRED' | translate | htmlToText  }}</div>
                    </div>
                    </div>
                    <div class="form-group my-3">
                    <button class="btn btn-stem mr-4" type="submit" >
                        {{ 'ACCEDI' | translate | htmlToText  }}
                    </button>

                    </div>
                   
                    <div class="small">*{{ 'CAMPI_OBBLIGATORI' | translate | htmlToText  }}</div>
            </form>

        </div>
      </div>


    </div>
  </div>
</div>
